module.exports = __webpack_public_path__ + "static/media/jeffPeterson.cc978d81.jpg";